<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div [class.edit-mode]="editMode()" class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Bibliotheek</h1>
        </div>
        <div class="controls">
            @if (AuthorisationService.hasFeature('libraryAddChapter') && !touchDevice()) {
                <div class="me-3 d-inline">
                    <mat-slide-toggle (ngModelChange)="editMode.set($event)" [ngModel]="editMode()" color="primary">
                        Beheer modus {{editMode() ? 'aan' : 'uit'}}
                    </mat-slide-toggle>
                </div>
            }
            @if (!isRead()) {
                <div
                    class="fab small"
                    id="btn-Back"
                    matTooltip="Terug naar overzicht"
                    matTooltipPosition="below"
                    routerLink="/">
                    <i class="fas fa-sign-out-alt"></i>
                </div>
            } @else {
                <div
                    (click)="logout()"
                    class="fab small"
                    id="btn-Exit"
                    matTooltip="Uitloggen"
                    matTooltipPosition="below">
                    <i class="fas fa-sign-out-alt"></i>
                </div>
            }
        </div>
    </div>
    @if (!selectedChapter()) {
        <div
            (cdkDropListDropped)="drop($event, libraryChapters())"
            [cdkDropListDisabled]="!editMode()"
            cdkDropList
            class="customer">
            @for (group of libraryChapters(); track group) {
                <div
                    [class.w-100]="editMode()"
                    cdkDrag
                    cdkDragHandle
                    class="chapter">
                    <div (click)="selectChapter(group)" class="action" matRipple>
                        <i class="{{group.file}} fa-4x"></i>
                        <span>{{group.name}}</span>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div>
            <button
                (click)="selectChapter()"
                class="mb-3"
                color="primary"
                mat-raised-button>
                <i class="fa-solid fa-chevrons-left"></i> Terug
            </button>
            <app-library-tree [editMode]="editMode()" [group]="selectedChapter()"></app-library-tree>
        </div>
    }
</div>
